<template lang="jade">
  tr
    td.td-data(rowspan='2')
      label(:class="{'can-select-row': autoCompleting, 'date-selected': selectedRow && autoCompleting, 'to-click': autoCompleting}",
      style="font-weight: 200;")
        input(type="checkbox", v-if="autoCompleting", @click="selectRow()", :checked="selectedRow")
        |  &nbsp {{ row.date | date }}

    td.group.no-padding(v-for="(group, i) in row.groups")
      div.cont-digits(:class="{ hasrror: isCutError, 'hasrror-left': isCutError && i == 0, 'hasrror-right': isCutError && i == 3}")
        .digit.center-element(:class="{to_verify: group[0].verify, blur_no_shadow: isToBlurDigit(group[0]), anim_blur: animBlur(group[0])}")
          img(:src="group[0].image_url", :class="{focused: inFocus(group[0])}")

          .white-img(v-if="!group[0].image_url || group[0].image_url == ''", :class="{focused: inFocus(group[0])}")
        .digit.center-element(:class="{to_verify: group[1].verify, blur_no_shadow: isToBlurDigit(group[1]), anim_blur: animBlur(group[1])}")
          img(:src="group[1].image_url", :class="{focused: inFocus(group[1])}")
          .white-img(v-if="!group[1].image_url || group[1].image_url == ''", :class="{focused: inFocus(group[1])}")

        .dots.center-element :

        .digit.center-element(:class="{to_verify: group[2].verify, blur_no_shadow: isToBlurDigit(group[2]), anim_blur: animBlur(group[2])}")
          img(:src="group[2].image_url", :class="{focused: inFocus(group[2])}")
          .white-img(v-if="!group[2].image_url || group[2].image_url == ''", :class="{focused: inFocus(group[2])}")

        .digit.center-element(:class="{to_verify: group[3].verify, blur_no_shadow: isToBlurDigit(group[3]), anim_blur: animBlur(group[3])}")
          img(:src="group[3].image_url", :class="{focused: inFocus(group[3])}")
          .white-img(v-if="!group[3].image_url || group[3].image_url == ''", :class="{focused: inFocus(group[3])}")


    td(rowspan="2")
      DayJourney(:rowNumber="rindex", :dj="dayJourney", :allow-edit="canEditCurrentSheet")

</template>

<script>
import moment from 'moment'
import DayJourney from '../common/DayJourney.vue'

export default {
  props: ['row', 'rindex'],
  components: {DayJourney},
  filters: {
    date (value) {
      return moment(value).lang('pt-br').format('DD ddd')
    }
  },
  computed: {
    isCutError () {
      let numOfValidSelectionThisLine = 0

      this.$store.getters.currentSheetRows[this.rindex].groups.forEach(group => {
        group.forEach(digit => {
          if (!digit.valid_selection) {
            numOfValidSelectionThisLine++
          }
        })
      })

      return numOfValidSelectionThisLine === 16
    },
    dayJourney () {
      console.log('lolol')
      return this.$store.state.Sheet.currentSheet.rows[this.rindex].dayJourney
    },
    seendingSheet () {
      return this.$store.getters.seendingSheet
    },
    canEditCurrentSheet () {
      return this.$store.getters.canEditCurrentSheet
    },
    autoCompleting () {
      return this.$store.getters.autoCompleting
    },
    selectedRow () { return this.$store.getters.selectedRowsAutoFill.includes(this.rindex) }
  },
  methods: {
    isToBlurDigit (digit) {
      return !digit.verify && !(this.$store.getters.currentDigit.id === digit.id)
    },
    animBlur (digit) {
      return digit.animBlur
    },
    inFocus (digit) {
      return this.$store.getters.currentDigit.id === digit.id
    },
    selectRow () {
      this.$store.commit('selectedRowsAutoFill', this.rindex)
    }
  }
}
</script>

<style scoped>
  .group {
    width: 21.5%
  }

  .td-data {
    width: 5%
  }

  .dots {
    width: 4%;
    height: 100%;
    float: left;
  }

  .digit {
    width: 22%;
    height: 100%;
    float: left;
    padding: 1px 2px 1px 2px;
  }

  .digit > img {
    /*filter: invert(100%);*/
    mix-blend-mode: multiply;
    width: 80%;
  }

  .cont-digits {
    width: 100%;
    height: 100%;
    display:inline-block
  }

  .hasrror {
    border-top: 3px solid rgba(220, 100, 100, 0.8);
    border-bottom: 3px solid rgba(220, 100, 100, 0.8);
  }

  .hasrror-left {
    border-left: 3px solid rgba(220, 100, 100, 0.8);
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  .hasrror-right {
    border-right: 3px solid rgba(220, 100, 100, 0.8);
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .td-cut-error {
    width: 7%;
    padding-left: 12px;
  }

  .white-img {
    width: 20px;
    height: 20px;
    z-index: 2000;
    background-color: white;
  }

  .td-cut-error button {
    width: 100%;
  }

  .to_verify {
    background-color: rgba(255, 70, 70, 0.1);
  }
  .date-selected {
    border-bottom: 2px solid mediumseagreen !important;
  }
  .can-select-row {
    border-bottom: 1px solid gray;
  }
</style>



// WEBPACK FOOTER //
// ImageSheet.vue?c720da6a